import React from "react";
import Form from "./Form";
import { useSelector } from "react-redux";
import { useSearchParams } from 'react-router-dom';
import { isCurrentActivePlan } from "./currentPlan";
import { isTeamMember } from "./teamMember";

const Intro = ({ subscription_plan_id, subscription, terms_conditions, subscription_agreement,enterprise }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const data = useSelector((state) => state.fetchCheckout.content);
  const { content, plan, member } = data;
  let action=searchParams.get("action")
  return (
    <>
      <div className="colL">
        <div className="inner">
          <h4>{plan.plan_name}</h4>
          {
            !enterprise && !action ?
            <p>
            {plan.tagline}
            <br />
            {/* Start your free {plan.trial_days} days trial */}
          </p>
          :
          ""
          }
          
          {
            isCurrentActivePlan({ planId: plan?.id, subscription }) ?
              <div className="alert alert-success"><strong>Subscribed!</strong> This is your current plan.</div>
              :
            isTeamMember(member) ?
              <div className="team_member_notice" role="status" data-testid="team-member-checkout-notice">
                <strong>Billing is managed by your account administrator.</strong>{" "}
                Your access comes from their plan, so there is nothing to buy here. If your
                access has stopped, ask them to update the card in Account Settings.
              </div>
              :
              <Form content={content} plan={plan} subscription={subscription} terms_conditions={terms_conditions} subscription_agreement={subscription_agreement} enterprise={enterprise} />
          }
        </div>
      </div>
    </>
  );
};

export default Intro;
